import axios from 'axios';
import API from '../endpoints';
import { useQuery } from '@tanstack/react-query';
import { Club, Team } from '@repo/types';
import { getAccessToken } from '../utils/getAccessToken';

// 30 minutes frontend cache for club detail query
const CACHE_TIME = 30 * 60 * 1000;

export const useClubBySlugQuery = (slug: string | undefined) => {
  return useQuery({
    queryKey: ['club', { slug: slug! }],
    queryFn: async () => {
      if (!slug) {
        return null;
      }

      return fetchClubBySlug(slug);
    },
    enabled: !!slug,
    staleTime: CACHE_TIME,
  });
};

export const fetchClubBySlug = async (slug: string): Promise<Club | null> => {
  const accessToken = getAccessToken();

  if (accessToken) {
    const { data } = await axios.get<(Club & { teams: Team[] }) | null>(`${API.endpoints.clubs}/${slug}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
    });

    return data;
  }

  const { data } = await axios.get<Club | null>(`${API.endpoints.clubs}/${slug}`);
  return data;
};
